import Vue from 'vue'
import Vuex from 'vuex'
import aimManager from './aimList'
import session from './session'
import dataView from './dataView'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    aimManager, // 意图管理
    session, // 会话记录
    dataView, //首页
  },
})
